module.exports = ".snackbar{\n    min-width: 250px;\n    margin-left: -125px;\n    background-color: #333;\n    color:#fff;\n    text-align: center;\n    border-radius: 2px;\n    padding: 16px;\n    position: fixed;\n    z-index: 1;\n    left:50%;\n    bottom: 30px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/snackbar/snackbar.component.css
// module id = ./src/app/shared/components/snackbar/snackbar.component.css
// module chunks = main